import { jsx as _jsx } from "react/jsx-runtime";
import { I18N_NAMESPACES } from '@as/cotopaxi';
import { TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { getGroupName } from '../../../util/PaymentGroupUtil';
export const PaymentGroupTitle = ({ group, disabled }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    return (_jsx(TextAlpha, { color: disabled ? 'neutral-disabled' : 'neutral', children: t(`buy.payment.group.${getGroupName(group)}`) }));
};
